// Danh sách hãng vận chuyển + dịch vụ tĩnh (port từ CRM tham chiếu).
// Phase 1 chỉ là dropdown UI — không gọi API hãng. Khi thêm provider mới,
// update cả CARRIERS và SERVICES.

// 'manual' = Ship ngoài (thuê người ngoài giao); 'self_ship' = Tự vận chuyển
// (shop tự giao). 'bus' = Xe Khách (gửi nhà xe). Cả 3 XỬ LÝ Y HỆT (không API, phí nhập tay, đổi trạng thái giao
// tay) — chỉ khác phân loại. Dùng isManualLike() cho mọi logic chung.
export type CarrierCode =
  | 'ghn'
  | 'ghtk'
  | 'vnpost'
  | 'jt'
  | 'vtp'
  | 'manual'
  | 'self_ship'
  | 'bus'

export type CarrierOption = {
  code: CarrierCode
  name: string
}

export type ServiceOption = {
  code: string
  name: string
}

export const CARRIERS: ReadonlyArray<CarrierOption> = [
  { code: 'ghtk', name: 'GHTK' },
  { code: 'ghn', name: 'GHN' },
  { code: 'vnpost', name: 'VNPost' },
  { code: 'jt', name: 'J&T' },
  { code: 'vtp', name: 'ViettelPost' },
  // 2 loại "giao tay" — KHÔNG gọi API hãng, phí ship NHẬP TAY (mặc định 0).
  // 'self_ship' = shop tự giao; 'manual' = thuê người ngoài giao.
  { code: 'self_ship', name: 'Tự vận chuyển' },
  { code: 'manual', name: 'Ship ngoài' },
  { code: 'bus', name: 'Xe Khách' },
]

export const SERVICES: Record<CarrierCode, ReadonlyArray<ServiceOption>> = {
  ghtk: [
    { code: 'road', name: 'Đường bộ' },
    { code: 'fly', name: 'Đường bay' },
  ],
  ghn: [
    { code: 'standard', name: 'Tiêu chuẩn' },
    { code: 'fast', name: 'Nhanh' },
  ],
  vnpost: [
    { code: 'ems', name: 'EMS' },
    { code: 'ect', name: 'Tiết kiệm' },
  ],
  jt: [{ code: 'standard', name: 'Tiêu chuẩn' }],
  vtp: [{ code: 'standard', name: 'Tiêu chuẩn' }],
  manual: [{ code: 'standard', name: 'Tiêu chuẩn' }],
  self_ship: [{ code: 'standard', name: 'Tiêu chuẩn' }],
  bus: [{ code: 'standard', name: 'Tiêu chuẩn' }],
}

// Loại "giao tay": Ship ngoài (manual) hoặc Tự vận chuyển (self_ship) hoặc Xe Khách (bus). Cả 3
// không gọi API hãng, phí nhập tay, đổi trạng thái giao bằng tay. Dùng cho mọi
// chỗ trước đây check `=== 'manual'` về mặt HÀNH VI (không phải hiển thị tên).
export function isManualLike(
  code: string | null | undefined,
): code is 'manual' | 'self_ship' | 'bus' {
  return code === 'manual' || code === 'self_ship' || code === 'bus'
}

export function isCarrierCode(value: string | null | undefined): value is CarrierCode {
  return value != null && (CARRIERS as ReadonlyArray<CarrierOption>).some((c) => c.code === value)
}

export function carrierName(code: string | null | undefined): string | null {
  if (!code) return null
  return CARRIERS.find((c) => c.code === code)?.name ?? code
}

export function serviceName(
  carrier: string | null | undefined,
  service: string | null | undefined,
): string | null {
  if (!service) return null
  if (!isCarrierCode(carrier)) return service
  return SERVICES[carrier].find((s) => s.code === service)?.name ?? service
}
